import { ROUTES } from '@/common/constants/routes';
import { HomeLayout } from '@/common/containers/Dashboard/Home/HomeLayout/HomeLayout';
import {
  useGetPTHomeAlerts,
  useGetPTHomeSecondaryActions,
} from '@/common/containers/Dashboard/Home/PTHomePage/PTHomePage.utils';
import { PTMealCardPocket } from '@/common/containers/Dashboard/Home/PTHomePage/PTMealCardPocket/PTMealCardPocket';
import { PocketCardsGrid } from '@/common/containers/Dashboard/Home/PocketCardsGrid/PocketCardsGrid';

export function PTMealHomePage() {
  const alerts = useGetPTHomeAlerts();
  const secondaryActions = useGetPTHomeSecondaryActions();

  return (
    <HomeLayout
      alertsSlot={alerts}
      pocketCardsSlot={
        <PocketCardsGrid>
          <PTMealCardPocket route={ROUTES.ACTIVITY} />
        </PocketCardsGrid>
      }
      secondaryActionsSlot={secondaryActions}
      activityRoute={ROUTES.ACTIVITY}
    />
  );
}
